export default [
  {
    path: '/competition/ranking-list',
    name: 'competition_ranking_list',
    props: (route: any) => ({ ...route.query, ...route.params }),
    component: () => import('../../views/competition/RankingList.vue'),
  },
  {
    path: '/competition/ranking-list-lantern-festival',
    name: 'competition_ranking_list_lantern_festival',
    props: (route: any) => ({ ...route.query, ...route.params }),
    component: () => import('../../views/competition/RankingListLanternFestival.vue'),
  },
]
